import { Phone, ArrowUpRight } from "lucide-react";
import { SITE } from "@/lib/siteConfig";

const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_emergency-lock-3/artifacts/elv18aza_photo-1558002038-1055907df827.jpeg",
    alt: "Ouverture de porte sans dégât - SOS Serrurier Express",
    label: "Ouverture de porte",
    tag: "Sans dégât",
    span: "md:col-span-7 md:row-span-2 aspect-[4/5] md:aspect-auto",
  },
  {
    src: "https://images.unsplash.com/photo-1582139329536-e7284fece509?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    alt: "Coffre-fort haute sécurité",
    label: "Coffres-forts",
    tag: "Certifié A2P",
    span: "md:col-span-5 aspect-[4/3]",
  },
  {
    src: "https://images.unsplash.com/photo-1759452003649-552896c8ed63?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    alt: "Clé dans serrure cylindrique",
    label: "Serrures A2P",
    tag: "Toutes marques",
    span: "md:col-span-5 aspect-[4/3]",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-white py-20 sm:py-28 reveal"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-600 mb-4">
              — Nos interventions en images
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] max-w-2xl">
              Portes,<br />serrures,<br /><span className="text-red-600">solutions.</span>
            </h2>
          </div>
          <a
            href={SITE.phoneHref}
            data-testid="gallery-cta"
            className="inline-flex items-center gap-2 self-start lg:self-auto bg-[#0A0A0A] hover:bg-red-600 text-white px-5 py-3 font-display font-bold uppercase text-xs tracking-[0.15em] transition-all"
          >
            <Phone className="w-4 h-4" strokeWidth={2.5} />
            Un projet similaire ?
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid md:grid-cols-12 gap-3 sm:gap-4">
          {PHOTOS.map((p, i) => (
            <div
              key={i}
              data-testid={`gallery-photo-${i}`}
              className={`relative group overflow-hidden border border-black/10 ${p.span} fade-up`}
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent pointer-events-none" />
              <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 text-white">
                <div className="inline-flex items-center gap-2 bg-red-600 px-2.5 py-1 text-[10px] uppercase tracking-[0.15em] font-bold mb-2">
                  {p.tag}
                </div>
                <div className="font-display font-black text-2xl sm:text-3xl uppercase tracking-tight">
                  {p.label}
                </div>
              </div>
              {/* Frame corner accent */}
              <div className="absolute top-3 right-3 w-9 h-9 border border-white/40 group-hover:border-white flex items-center justify-center bg-black/20 backdrop-blur-sm transition">
                <ArrowUpRight className="w-4 h-4 text-white" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
